import React from 'react';
import { Snackbar } from '@material-ui/core';

const CustomAlert = ({ children, timeout, autoClose, onClose }) => {
  return (
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => {
        autoClose && onClose();
      }}
      autoHideDuration={timeout}
    >
      {children}
    </Snackbar>
  );
};

export default CustomAlert;
